import { render, staticRenderFns } from "./LandingOptional.vue?vue&type=template&id=6940b5da&"
import script from "./LandingOptional.vue?vue&type=script&lang=js&"
export * from "./LandingOptional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports